module.exports = __webpack_public_path__ + "static/media/Mattress-Price-Tag.9d672646.mp4";